<template>
    <div class="app-showcase-process-step__one">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="app-showcase-process-step__media text-center wow move-up">
                    <img :src="img" class="img-fluid" alt="thumbnail">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="app-showcase-process-step__content text-first-div section-space--mt_40">
                    <div class="app-showcase__inner">
                        <div class="sub__title mb-20 wow move-up">
                            <h6 class="font-weight--blod">Money's a team game</h6>
                        </div>
                        <h2 class="font-weight--light wow move-up sub-title">Dont't be a <br>grinch, set<br>goals and <br><span class="white-sub-title">save with<br>your friends.</span></h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'LoginScreen',
        data (){
            return {
                img: require("../assets/img/iphone3.png"),
            }
        }
    };
</script>

<style>
     .text-first-div{
        padding-top:20%
    }
    .sub-title{
        color:#3D3D3D;
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: 900;
    }
    .white-sub-title{
        color:white !important;
    }
</style>